(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duranor-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('duranor-reviews')) {
    customElements.define('duranor-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;
        this.events = new AbortController();
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.more = this.querySelector('[data-more]');
        this.sort = this.querySelector('[data-sort]');
        this.status = this.querySelector('[data-status]');
        this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 8);
        this.limit = this.hasAttribute('data-editor') ? this.cards.length : this.pageSize;
        const options = { signal: this.events.signal };
        this.reviewDialog = this.querySelector('[data-review-dialog]');
        this.infoDialog = this.querySelector('[data-info-dialog]');
        this.dialogs = [this.reviewDialog, this.infoDialog];
        this.cards.forEach(card => {
          const opener = card.querySelector('[data-open-review]');
          if (opener) opener.hidden = false;
        });
        this.addEventListener('click', event => {
          const infoButton = event.target.closest('[data-open-verification]');
          if (infoButton && this.contains(infoButton)) {
            event.preventDefault();
            event.stopPropagation();
            const source = infoButton.parentElement.querySelector('[data-verification-content]');
            const content = this.infoDialog.querySelector('[data-info-content]');
            content.replaceChildren(...Array.from(source.childNodes, node => node.cloneNode(true)));
            this.showDialog(this.infoDialog, infoButton);
            return;
          }
          const opener = event.target.closest('[data-open-review]');
          if (opener && this.contains(opener)) {
            const card = opener.closest('[data-review]');
            const content = this.reviewDialog.querySelector('[data-review-content]');
            const photo = card.querySelector('.dr-reviews__photo');
            const body = card.querySelector('.dr-reviews__body');
            content.replaceChildren();
            if (photo) {
              const copy = photo.cloneNode(true);
              copy.loading = 'eager';
              copy.sizes = '(max-width:749px) 100vw, 410px';
              content.appendChild(copy);
            }
            const bodyCopy = body.cloneNode(true);
            const verifiedLabel = bodyCopy.querySelector('[data-verified-label]');
            const infoControl = bodyCopy.querySelector('[data-open-verification]');
            if (verifiedLabel) verifiedLabel.hidden = true;
            if (infoControl) infoControl.hidden = false;
            content.appendChild(bodyCopy);
            this.showDialog(this.reviewDialog, opener);
            return;
          }
          const closeButton = event.target.closest('[data-close-dialog]');
          if (closeButton && this.contains(closeButton)) closeButton.closest('dialog').close();
        }, options);
        this.dialogs.forEach(dialog => {
          let backdropStart = false;
          const outside = event => {
            const r = dialog.getBoundingClientRect();
            return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
          };
          dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog && outside(event); }, options);
          dialog.addEventListener('click', event => {
            if (backdropStart && event.target === dialog && outside(event)) dialog.close();
            backdropStart = false;
          }, options);
          dialog.addEventListener('close', () => {
            if (dialog.returnFocus?.isConnected) dialog.returnFocus.focus({ preventScroll: true });
          }, options);
        });
        this.querySelectorAll('[data-controls]').forEach(el => { el.hidden = false; });
        this.more.addEventListener('click', () => {
          const next = this.cards[this.limit];
          this.limit += this.pageSize;
          this.render();
          if (next) {
            next.tabIndex = -1;
            next.focus({ preventScroll: true });
          }
          this.status.textContent = `${Math.min(this.limit, this.cards.length)} / ${this.cards.length} ${this.status.dataset.label}`;
        }, options);
        this.sort?.addEventListener('change', () => {
          const direction = this.sort.value;
          this.cards.sort((a, b) => {
            const original = Number(a.dataset.index) - Number(b.dataset.index);
            if (direction === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || original;
            if (direction === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || original;
            return original;
          });
          this.cards.forEach(card => this.grid.appendChild(card));
          this.limit = this.hasAttribute('data-editor') ? this.cards.length : this.pageSize;
          this.render();
        }, options);
        this.render();
      }
      showDialog(dialog, trigger) {
        dialog.returnFocus = trigger;
        if (!dialog.open) dialog.showModal();
      }
      render() {
        this.cards.forEach((card, i) => { card.hidden = i >= this.limit; });
        this.more.hidden = this.limit >= this.cards.length;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.dialogs?.forEach(dialog => { if (dialog.open) dialog.close(); });
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
